import React from "react";

class UnitFullPath extends React.Component {
  render() {
    const {
      path = "",
      name = "",
      replaceClass = "",
      customClass = "",
    } = this.props;

    return (
      <div
        className={
          replaceClass !== ""
            ? replaceClass
            : `text-xs text-gray-600 ${customClass}`
        }
      >
        {path === "/" || path === "" ? "" : path}/{name}
      </div>
    );
  }
}

export default UnitFullPath;
